import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ProductCollectionService from "services/Setup/Organization/productCollectionService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productCollectionList: [],
  productCollectionListApproval: [],
  getCount: 0,
};

export const postProductCollection = createAsyncThunk(
  "productCollection/postProductCollection",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~postProductCollection dataqwerty:", data);
    try {
      const response = await ProductCollectionService.postProductCollection(
        data
      );

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const editProductCollection = createAsyncThunk(
  "productCollection/editProductCollection",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProductCollectionService.editProductCollection(
        data
      );

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const deleteProductCollection = createAsyncThunk(
  "productCollection/deleteProductCollection",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProductCollectionService.deleteProductCollection(
        data
      );

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getProductCollectionList = createAsyncThunk(
  "productCollection/getProductCollectionList",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getProductCollectionListuserInput:", userInput);
    try {
      const response = await ProductCollectionService.getProductCollectionList(
        userInput
      );
      console.log("🚀 ~ getProductCollectionDetailresponse:", response);
      if (response.status === 200) {
        // notification.success({
        //   message: response.data.status,
        //   description: response.data.message,
        //   duration: 3,
        // });
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~getProductCollectionList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getProductCollectionApproval = createAsyncThunk(
  "productCollection/getProductCollectionApproval",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getProductCollectionListuserInput:", userInput);
    try {
      const response =
        await ProductCollectionService.getProductCollectionApproval(userInput);
      console.log("🚀 ~ getProductCollectionDetailresponse:", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~getProductCollectionList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const putProductCollectinRequest = createAsyncThunk(
  "productCollection/putProductCollectinRequest",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~putProductCollectinRequest userInput:", userInput);
    try {
      const response =
        await ProductCollectionService.putProductCollectinRequest(userInput);
      console.log("🚀 ~ getProductCollectionDetailresponse:", response);
      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~getProductCollectionList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getProductCollectionReturn = createAsyncThunk(
  "productCollection/getProductCollectionReturn",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getProductCollectionListuserInput:", userInput);
    try {
      const response =
        await ProductCollectionService.getProductCollectionReturn(userInput);
      console.log("🚀 ~ getProductCollectionDetailresponse:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~getProductCollectionList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getProductCollectionReject = createAsyncThunk(
  "productCollection/getProductCollectionReject",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getProductCollectionListuserInput:", userInput);
    try {
      const response =
        await ProductCollectionService.getProductCollectionReject(userInput);
      console.log("🚀 ~ getProductCollectionDetailresponse:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~getProductCollectionList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getProductCollectionApprovalList = createAsyncThunk(
  "productCollection/getProductCollectionApprovalList", // Ubah nama action type
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getProductCollectionListuserInput:", userInput);
    try {
      const response =
        await ProductCollectionService.getProductCollectionApprovalList(
          userInput
        );

      if (response.status === 200) {
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~getProductCollectionList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getProductCollectionDetail = createAsyncThunk(
  "productCollection/getProductCollectionDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await ProductCollectionService.getProductCollectionDetail(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const uploadProductCollection = createAsyncThunk(
  "subProductOffering/uploadProductCollection",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~uploadProductCollection data:", data);
    try {
      const response = await ProductCollectionService.uploadProductCollection(
        data
      );
      
      console.log("🚀 ~uploadProductCollection response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      console.log("🚀 ~ postProductCollectionqwert error:", error);
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const ProductCollectionSlice = createSlice({
  name: "productCollection",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    falseMessage: (state) => {
      state.message = "";
    },
  },

  extraReducers: (builder) => {
    builder
      //post
      .addCase(postProductCollection.pending, (state) => {
        state.loading = true;
      })
      .addCase(postProductCollection.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(postProductCollection.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // Edit
      .addCase(editProductCollection.pending, (state) => {
        state.loading = true;
      })
      .addCase(editProductCollection.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(editProductCollection.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //list
      .addCase(getProductCollectionList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProductCollectionList.fulfilled, (state, action) => {
        console.log(
          "🚀 ~ .addCase ~ action getProductCollectionList:",
          action.payload
        );
        state.loading = false;
        state.productCollectionList = action.payload.data;
        state.getCount = action.payload.count;
      })
      .addCase(getProductCollectionList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //list approval
      .addCase(getProductCollectionApprovalList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProductCollectionApprovalList.fulfilled, (state, action) => {
        console.log(
          "🚀 ~ .getProductCollectionApprovalList ~ action:",
          action.payload
        );
        state.loading = false;
        state.productCollectionListApproval = action.payload.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getProductCollectionApprovalList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //approval
      .addCase(getProductCollectionApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductCollectionApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getProductCollectionApproval.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Return
      .addCase(getProductCollectionReturn.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductCollectionReturn.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getProductCollectionReturn.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Reject
      .addCase(getProductCollectionReject.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductCollectionReject.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getProductCollectionReject.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Request
      .addCase(putProductCollectinRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(putProductCollectinRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(putProductCollectinRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //detail
      .addCase(getProductCollectionDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductCollectionDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getProductCollectionDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //delete
      .addCase(deleteProductCollection.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProductCollection.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteProductCollection.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // 
      .addCase(uploadProductCollection.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadProductCollection.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadProductCollection.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading, falseMessage } =
  ProductCollectionSlice.actions;

export default ProductCollectionSlice.reducer;
